<template>
  <div style="background-color: rgba(255, 255, 255, 0.9)">
    <v-container>
      <div class="site-padding">
        <div>AMBASADORZY AKCJI</div>
        <swiper :options="swiper2Option">
          <swiper-slide class="ambasadors">
            <!--            <router-link :to="{ name: 'Ambasadors' }" class="ambasadors&#45;&#45;link">-->
            <img
              src="./../../assets/images/face3.png"
              alt="slide.description"
              class="ambasadros--image"
            />
            <div class="ambasadors--text-container">
              <div class="ambasadors--title">prof. dr hab. n. med.</div>
              <div class="ambasadors--name">Bożena Romanowska-Dixon</div>
              <div class="ambasadors--position">
                Członek Zarządu Polskiego Towarzystwa Okulistycznego
              </div>
            </div>
            <!--            </router-link>-->
          </swiper-slide>
          <swiper-slide class="ambasadors">
            <!--            <router-link :to="{ name: 'Ambasadors' }" class="ambasadors&#45;&#45;link">-->
            <img
              src="./../../assets/images/face2.png"
              alt="slide.description"
              class="ambasadros--image"
            />
            <div class="ambasadors--text-container">
              <div class="ambasadors--title">prof. dr hab. n. med.</div>
              <div class="ambasadors--name">Iwona Grabska-Liberek</div>
              <div class="ambasadors--position">
                Przewodniczącą sekcji Schorzeń Rogówki Polskiego Towarzystwa
                Okulistycznego. Inicjatorka akcji w Polsce
              </div>
            </div>
            <!--            </router-link>-->
          </swiper-slide>

          <swiper-slide class="ambasadors">
            <img
              src="./../../assets/images/mrukwa-kominek.png"
              alt="slide.description"
              class="ambasadros--image"
            />
            <div class="ambasadors--text-container">
              <div class="ambasadors--title">prof. dr hab. n. med.</div>
              <div class="ambasadors--name">Ewa Mrukwa-Kominek</div>
              <div class="ambasadors--position">
                PREZES POLSKIEGO TOWARZYSTWA OKULISTYCZNEGO
              </div>
            </div>
          </swiper-slide>

          <swiper-slide class="ambasadors">
            <img
              src="./../../assets/images/misiuk-hojlo-2.png?v=1"
              alt="slide.description"
              class="ambasadros--image"
            />
            <div class="ambasadors--text-container">
              <div class="ambasadors--title">prof. dr hab. n. med.</div>
              <div class="ambasadors--name">Marta Misiuk-Hojło</div>
              <div class="ambasadors--position">
                CZŁONEK ZARZĄDU GŁÓWNEGO POLSKIEGO TOWARZYSTWA OKULISTYCZNEGO
              </div>
            </div>
          </swiper-slide>

          <swiper-slide class="ambasadors">
            <!--            <router-link :to="{ name: 'Ambasadors' }" class="ambasadors&#45;&#45;link">-->

            <img
              src="./../../assets/images/face4.png"
              alt="slide.description"
              class="ambasadros--image"
            />
            <div class="ambasadors--text-container">
              <div class="ambasadors--title">prof. dr hab. n. med.</div>
              <div class="ambasadors--name">Jacek P. Szaflik</div>
              <div class="ambasadors--position">
                CZŁONEK ZARZĄDU GŁÓWNEGO I PRZEWODNICZĄCY SEKCJI JASKRY
                POLSKIEGO TOWARZYSTWA OKULISTYCZNEGO
              </div>
            </div>
            <!--            </router-link>-->
          </swiper-slide>

          <swiper-slide class="ambasadors">
            <img
              src="./../../assets/images/dobrowolski.png"
              alt="Dariusz Dobrowolski"
              class="ambasadros--image"
            />
            <div class="ambasadors--text-container">
              <div class="ambasadors--title">dr hab. n. med.</div>
              <div class="ambasadors--name">Dariusz Dobrowolski</div>
              <div class="ambasadors--position">
                Wiceprezes Polskiego Towarzystwa Okulistycznego
              </div>
            </div>
          </swiper-slide>

          <swiper-slide class="ambasadors">
            <img
              src="./../../assets/images/stopa-2.png"
              alt="Marcin Stopa"
              class="ambasadros--image"
            />
            <div class="ambasadors--text-container">
              <div class="ambasadors--title">prof. dr hab. n. med.</div>
              <div class="ambasadors--name">Marcin Stopa</div>
              <div class="ambasadors--position">
                Prezes Elekt Polskiego Towarzystwa Okulistycznego
              </div>
            </div>
          </swiper-slide>
        </swiper>

        <div class="sparator-container">
          <div class="sparator-rectangle"></div>
        </div>

        <div class="my-3" v-if="honor.length > 0">PATRONI HONOROWI</div>
        <swiper :options="honorSwiperOption">
          <swiper-slide
            v-for="(slide, index) in honor"
            :key="'sponsor' + index"
          >
            <a :href="slide.link" target="_blank" class="honor--link">
              <img :src="slide.image" :alt="slide.description" />
            </a>
          </swiper-slide>
        </swiper>

        <div class="sparator-container">
          <div class="sparator-rectangle"></div>
        </div>

        <div class="my-3" v-if="sponsors.length > 0">PARTNERZY</div>
        <swiper v-if="sponsors.length > 0" :options="swiperOption">
          <swiper-slide
            v-for="(slide2, index) in sponsors"
            :key="'sponsors' + index"
          >
            <a :href="slide2.link" target="_blank" class="partners--link">
              <img :src="api + slide2.image" :alt="slide2.description" />
            </a>
          </swiper-slide>
        </swiper>

        <div class="sparator-container">
          <div class="sparator-rectangle"></div>
        </div>

        <div class="my-3">PATRONI MEDIALNI</div>
        <swiper v-if="medias.length > 0" :options="swiperOption">
          <swiper-slide
            v-for="(slide2, index) in medias"
            :key="'media' + index"
          >
            <a :href="slide2.link" target="_blank" class="partners--link">
              <img :src="api + slide2.image" :alt="slide2.description" />
            </a>
          </swiper-slide>
        </swiper>
      </div>
    </v-container>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: ".swiper-pagination",
        },
        centerInsufficientSlides: true,
        // Default parameters for smallest screen
        slidesPerView: 1,
        spaceBetween: 10,
        autoHeight: true,
        // Responsive breakpoints
        breakpointsInverse: true,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          1440: {
            slidesPerView: 6,
            spaceBetween: 40,
          },
          1920: {
            slidesPerView: 7,
            spaceBetween: 40,
          },
        },
      },
      swiper2Option: {
        loop: true,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: ".swiper-pagination",
        },
        // Default parameters for smallest screen
        slidesPerView: 1,
        spaceBetween: 10,
        // Responsive breakpoints
        breakpointsInverse: true,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          // when window width is >= 480px
          500: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          // when window width is >= 768px
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          // when window width is >= 1024px
          1280: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
        },
      },
      honorSwiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: ".swiper-pagination",
        },
        // Default parameters for smallest screen
        slidesPerView: 1,
        spaceBetween: 10,
        // Responsive breakpoints
        breakpointsInverse: true,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          // when window width is >= 480px
          500: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          // when window width is >= 768px
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        },
      },
      mainSponsorSwiperOption: {
        loop: false,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: ".swiper-pagination",
        },
        // Default parameters for smallest screen
        slidesPerView: 1,
        spaceBetween: 10,
      },
      mainSponsor: [],
      sponsors: [],
      medias: [],
      honor: [
        {
          image: "/static/images/honor/marsz-mazowieckie.png?v=2",
          description: "",
          link: "",
        },
        {
          image: "/static/images/honor/marsz-sejmu.png?v=2",
          description: "",
          link: "",
        },
        {
          image: "/static/images/honor/marsz-senatu.png?v=2",
          description: "",
          link: "",
        },
        {
          image: "/static/images/honor/prez-bialystok.png?v=2",
          description: "",
          link: "",
        },
        {
          image: "/static/images/honor/prez-wrszawa.png?v=2",
          description: "",
          link: "",
        },
        {
          image: "/static/images/honor/mazowsze.png?v=2",
          description: "Urząd Marszałkowski Województwa Mazowieckiego",
          link: "https://mazovia.pl/",
        },
        {
          image: "/static/images/honor/zwrp-80.png?v=2",
          description: "Związek Województw RP",
          link: "https://polskieregiony.pl/",
        },
        {
          image: "/static/images/honor/muw-80.png?v=2",
          description: "Mazowiecki Urząd Wojewódzki",
          link: "https://www.gov.pl/web/uw-mazowiecki",
        },
        {
          image: "/static/images/honor/nil.png?v=2",
          description: "NIL",
          link: "",
        },
      ],
      api: `${process.env.APP_URL}/uploads/`,
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  mounted() {
    this.fetchSponsors();
    this.fetchMedias();
  },
  methods: {
    fetchSponsors() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/sponsors`,
      }).then((result) => {
        this.sponsors = result.data.filter(
          (sponsor) => sponsor.description !== "Viatris"
        );
        this.mainSponsors = result.data.filter(
          (sponsor) => sponsor.description === "Viatris"
        );
      });
    },
    fetchMedias() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/medias`,
      }).then((result) => {
        this.medias = result.data;
      });
    },
    showAmbasadors() {
      this.$router.push({ path: "Ambasadors" });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
@import 'swiper/dist/css/swiper.css';

.partners--link {
  max-width: 140px;
  max-height: 80px;

  img {
    width: 140px;
    height:auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.ambasadros--image {
  width: 120px;
  float: left;
}

.sliders-container {
  background-color: #ffffff;
  opacity: 0.95;
}

.ambasadors--title {
  font-family: 'Fira Sans', sans-serif;
  font-size: 12px;
  padding-top: 15px;
}

@media only screen and (max-width: 1450px) {
  .ambasadors--title {
    padding-top: 10px;
  }
}

.ambasadors--name {
  font-family: 'Fira Sans', sans-serif;
  font-size: 12px;
  font-weight: 900;
  color: #275271;
  padding-bottom: 10px;
}

.ambasadors--position {
  font-family: 'Fira Sans', sans-serif;
  font-size: 10px;
  text-transform: uppercase;
}

.sparator-container {
  border-bottom: 1px solid black;
  margin: 10px 0px;
}

.sparator-rectangle {
  width: 115px;
  height: 8px;
  background-color: #275271;
}

.ambasadors--text-container {
  padding-left: 120px;
  padding-bottom: 5px;
  top: 0;
  margin: auto;
  min-height: 100%;
}

.ambasadors--link {
  text-decoration: none;
  color: #000;
}

.honor--link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;

  img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    display: block;
    object-fit: contain;
    }
}

.swiper-container-autoheight .swiper-slide {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/SponsorsSlider.vue